import * as api from '../api';
import * as types from '../constants/actions';
import { makeAsyncAction } from '../../../ui-lottery/src/utils/async_utils';

export const fetchReservation = makeAsyncAction(
  types.FETCH_RESERVATION,
  (resId) => () => api.getReservation(resId),
  'reservation'
);

export const createReservation = makeAsyncAction(
  types.CREATE_RESERVATION,
  (reservation) => () => api.createReservation(reservation),
  'reservation'
);

export const updateReservation = makeAsyncAction(
  types.UPDATE_RESERVATION,
  (reservation) => () => api.updateReservation(reservation),
  'reservation'
);
